import blank from '../assets/tile_images/blank.png';
import plains from   '../assets/tile_images/plains.png';
import forest from   '../assets/tile_images/forest.png';
import hills from   '../assets/tile_images/hills.png';
import swamp from   '../assets/tile_images/swamp.png';
import mountains from   '../assets/tile_images/mountains.png';

export const tilesPublicImagesUrls = {
    blank :   '/assets/tile_images/blank.png',
    plains :   '/assets/tile_images/plains.png',
    forest :   '/assets/tile_images/forest.png',
    hills :   '/assets/tile_images/hills.png',
    swamp :   '/assets/tile_images/swamp.png',
    mountains :   '/assets/tile_images/mountains.png'
}

export const importedTileImages = {
    blank: blank,
    plains:plains,
    forest:forest,
    hills:hills,
    swamp:swamp,
    mountains:mountains,
}